<script setup>
import {computed} from "vue";

const props = defineProps({
  value: {
    type: [Number, null],
    required: true,
  }
});

const bgColorClass = computed(() => {
  const valueInt = props.value === null ? null : parseInt(props.value);

  if (!valueInt) return 'tw-bg-grey'
  if (valueInt === 1) return 'tw-bg-pink';
  if (valueInt <= 5) return 'tw-bg-purple';

  return 'tw-bg-everest-bright';
});

</script>

<template>
  <div
    :class="[
      'tw-rounded-xl tw-w-10 tw-h-10 tw-py-1 tw-font-semibold tw-text-lg tw-text-white tw-flex tw-items-center tw-justify-center',
      `${bgColorClass}`,
    ]"
  >
    {{ value ?? '-' }}
  </div>
</template>
